import toast from 'react-hot-toast';

import React from 'react';

/**
 * Display error toast with specific error message
 * @param {string} message - Error message to display
 * @param {Object} error - Error object from Supabase or other sources
 */
export const showErrorToast = (message, error = null) => {
  let errorMessage = message;
  
  // Extract specific error message from Supabase error object
  if (error) {
    if (error?.message) {
      errorMessage = `${message}: ${error?.message}`;
    } else if (error?.error_description) {
      errorMessage = `${message}: ${error?.error_description}`;
    } else if (typeof error === 'string') {
      errorMessage = `${message}: ${error}`;
    }
  }
  
  toast?.error(errorMessage, {
    duration: 5000,
    position: 'top-right',
    style: {
      background: '#fef2f2',
      color: '#991b1b',
      border: '1px solid #fecaca',
      padding: '16px',
      borderRadius: '8px'
    },
    icon: '❌'
  });
};

/**
 * Display success toast with confirmation message
 * @param {string} message - Success message to display
 */
export const showSuccessToast = (message) => {
  toast?.success(message, {
    duration: 3000,
    position: 'top-right',
    style: {
      background: '#f0fdf4',
      color: '#166534',
      border: '1px solid #bbf7d0',
      padding: '16px',
      borderRadius: '8px'
    },
    icon: '✅'
  });
};

/**
 * Display loading toast during async operations
 * @param {string} message - Loading message to display
 * @returns {string} Toast ID for dismissal
 */
export const showLoadingToast = (message) => {
  return toast?.loading(message, {
    position: 'top-right',
    style: {
      background: '#eff6ff',
      color: '#1e40af',
      border: '1px solid #bfdbfe',
      padding: '16px',
      borderRadius: '8px'
    }
  });
};

/**
 * Dismiss a specific toast by ID
 * @param {string} toastId - Toast ID to dismiss
 */
export const dismissToast = (toastId) => {
  toast?.dismiss(toastId);
};

/**
 * Display warning toast
 * @param {string} message - Warning message to display
 */
export const showWarningToast = (message) => {
  toast(message, {
    duration: 4000,
    position: 'top-right',
    style: {
      background: '#fffbeb',
      color: '#92400e',
      border: '1px solid #fde68a',
      padding: '16px',
      borderRadius: '8px'
    },
    icon: '⚠️'
  });
};

export default {
  error: showErrorToast,
  success: showSuccessToast,
  loading: showLoadingToast,
  warning: showWarningToast,
  dismiss: dismissToast
};